export default __webpack_public_path__ + "static/media/GroovyGravity_05.27ad0009.png";